var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isLoading,
      expression: "!isLoading"
    }],
    staticClass: "splash-page splash-page-mobile splash-page--mobile"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOptions,
      "slides-per-view": 2,
      "space-between": 50
    },
    on: {
      "slideChange": _vm.onSlideChange,
      "touchMove": function touchMove() {
        return _vm.setOpacity();
      },
      "touchEnd": function touchEnd() {
        return _vm.setOpacity(1);
      }
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "step1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('rotate'),
      expression: "verifyModuleVisibility('rotate')"
    }]
  }, [_c('div', {
    class: ['component-img', _vm.regionIsApac ? 'component-img--apac' : ''],
    style: {
      opacity: _vm.opacity
    }
  }, [_vm._t("default")], 2), _c('div', {
    class: ['logo', _vm.regionIsApac ? 'logo--apac' : '']
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/customs-logo.png")
    }
  })]), _c('div', {
    class: ['rotate-up', _vm.regionIsApac ? 'rotate-up--apac' : '']
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/rotate-up.png")
    }
  })]), _c('transition', {
    attrs: {
      "name": "hand-img-fade"
    }
  }, [!_vm.isTouchStarted ? _c('div', {
    class: ['hand-img', _vm.regionIsApac ? 'hand-img--apac' : '']
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/hand.png")
    }
  })]) : _vm._e()]), _c('div', {
    class: ['rotate-down', _vm.regionIsApac ? 'rotate-down--apac' : '']
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/rotate-down.png")
    }
  })]), _c('div', {
    class: ['label-rotate-down', _vm.regionIsApac ? 'label-rotate-down--apac' : ''],
    style: {
      opacity: _vm.opacity
    }
  }, [_c('label', [_vm._v(" " + _vm._s(this.getRotateTranslation()) + " ")])])], 1)])]), _c('swiper-slide', [_c('div', {
    staticClass: "step2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('header'),
      expression: "verifyModuleVisibility('header')"
    }],
    class: ['header-tools', _vm.regionIsApac ? 'apac' : '']
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('headerTools')))]), _c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/see-all-parts-arrow-step2.png")
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('faqs'),
      expression: "verifyModuleVisibility('faqs')"
    }],
    class: ['checkout-faqs', _vm.regionIsApac ? 'apac' : '']
  }, [_c('button', {
    attrs: {
      "id": "faqs"
    },
    on: {
      "click": _vm.faqsAction
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getTranslation('faqs')))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('tabs'),
      expression: "verifyModuleVisibility('tabs')"
    }],
    staticClass: "add-your-own-all"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('addYourOwn')))]), _c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/swipe-to-access-arrow-step3.png")
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verifyModuleVisibility('all_parts'),
      expression: "verifyModuleVisibility('all_parts')"
    }],
    staticClass: "see-all-customize-parts"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('allParts')))]), _c('img', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/images/customizer/see-all-parts-arrow-step2.png")
    }
  })])])]), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1), _c('modal-button-nav', {
    ref: "modalButtonNav",
    staticClass: "button-nav",
    attrs: {
      "cta-primary-button": _vm.skipToGetStartedTranslation,
      "show-icon-button": false,
      "show-cta-secondary-button": false,
      "show-cta-primary-button": true,
      "block-cta-primary-button": false
    },
    on: {
      "ctaPrimaryAction": _vm.onSkip
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }